import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../../store/store';
import {
  setFilteredProducts,
  setCategories,
  setPageSize,
  setIsLoading,
  setCurrentFilter,
  clearProductPanelState,
  setCurrentPage,
  setSelectedCategoryId,
} from '../../store/slices/productPanel/productPanelSlice';

import { ProductPanelFilter } from '../../types/productpanel/ProductPanelFilter';
import ProductPanelService from '../../services/product/ProductPanelService';
import { useSale } from '../sale/useSale';

const useProductPanel = () => {
  const dispatch: AppDispatch = useDispatch();
  const { form } = useSale();
  const {
    filteredProducts,
    categories,
    productsByCategory,
    paginator,
    pageSize,
    currentPage,
    selectedCategoryId,
    isLoading,
    currentFilter,
  } = useSelector((state: RootState) => state.productPanel);

  const fetchFilteredProducts = async (
    filters: ProductPanelFilter,
    page: number = 0,
    size: number = pageSize
  ) => {
    try {
      dispatch(setIsLoading(true));

      const response = await ProductPanelService.getFilteredProducts(filters, page, size);
      // console.log(response);
      if (response?.content) {
        dispatch(setFilteredProducts(mapPaginatedResponse(response)));
        dispatch(setCurrentFilter(filters));
      }
    } catch (error) {
      console.error('❌ Error al filtrar productos:', error);
    } finally {
      dispatch(setIsLoading(false));
    }
  };


  const fetchCategories = async () => {
    try {
      const branchId = form.branch?.id; // 👈 Asegúrate que este valor exista
      if (!branchId) return;

      const response = await ProductPanelService.getAvailableCategories(branchId);
      dispatch(setCategories(response));
    } catch (error) {
      console.error('❌ Error al obtener categorías:', error);
    }
  };


  const mapPaginatedResponse = (response: any) => ({
    content: response.content,
    paginator: {
      number: response.number,
      size: response.size,
      totalPages: response.totalPages,
      totalElements: response.totalElements,
      first: response.first,
      last: response.last,
    },
  });


  const updatePageSize = (size: number) => {
    dispatch(setPageSize(size));
  };

  const updateCurrentPage = (page: number) => {
    dispatch(setCurrentPage(page));
  };

  const setSelectedCategory = (id: number | null) => {
    dispatch(setSelectedCategoryId(id));
  };

  const resetProductPanelState = () => {
    dispatch(clearProductPanelState());
  };



  return {
    filteredProducts,
    categories,
    productsByCategory,
    paginator,
    pageSize,
    currentPage,
    selectedCategoryId,
    isLoading,
    currentFilter,

    fetchFilteredProducts,
    fetchCategories,
    updatePageSize,
    updateCurrentPage,
    setSelectedCategory,
    resetProductPanelState,
  };
};

export default useProductPanel;
